/**
 * ADGMQ
 * imedia
 *
 * Tinymce
 */

(function($) {
  $(document).ready(function() {
    var tinyOptions = {
      selector: 'textarea.tinymce',
      plugins: 'link',
      toolbar: 'bold italic | link',
      menubar: '',
      forced_root_block: false,
      force_p_newlines: false,
      force_br_newlines: true,
      convert_newlines_to_brs: true,
      default_link_target: '_blank',
      link_assume_external_targets: true,
      target_list: false,
      link_title: false,
      language: 'fr_FR',
    };

    /**
     * Init tinymce
     */
    tinymce.init(tinyOptions);
  });
})(jQuery);
